import { ListingDetailTranslation } from 'locales/de/pages/listingDetail';

const en: ListingDetailTranslation = {
  deleteFailed: 'The listing could not be deleted',
  deleteSuccessful: 'The listing was successfully deleted',
  deleteConfirm: {
    title: 'Confirm deletion',
    message: 'Do you really want to delete this listing? This action cannot be undone.'
  },
  postedBy: 'Posted by',
  postedOn: 'on {{date}}'
};

export default en;
